/* eslint-disable @gorazdo/preact/prefer-classname */
/* eslint-disable @gorazdo/preact/forbid-render-arguments */
import { Component } from 'preact'
import { z } from 'zod'
import QuickLink from './QuickLink'
import QuickLinksList from './QuickLinksList'
import ShowMoreButton from './ShowMoreButton'

interface State {
  showAll?: boolean
}

export const widgetName = 'quick_links' as const

export const config = z.object({
  title: z.string().optional(),
  quickLinks: z
    .array(
      z.object({
        title: z.string(),
        url: z.string(),
        description: z.string(),
        openNewTab: z.boolean(),
        iconSrc: z.string().or(z.null()),
        imageSrc: z.string().or(z.null())
      })
    )
    .default([]),
  enableBorder: z.boolean(),
  borderRadius: z.number()
})

interface QuickLinkItem {
  title: string
  url: string
  description: string
  openNewTab: boolean
  imageSrc: string | null
  iconSrc: string | null
}

interface Props {
  showAll?: boolean
  data: QuickLinkItem[]
  title?: string
  itemsPerContainer: number
  settings: {
    enableBorder: boolean
    borderRadius: number
  }
}

export default class QuickLinksContainer extends Component<Props, State> {
  constructor(props: Props) {
    super()
    this.state = {
      showAll: props.showAll
    }
    this.showMoreHandler = this.showMoreHandler.bind(this)
  }

  showMoreHandler() {
    this.setState({
      showAll: !this.state.showAll
    })
  }

  render(props: Props, state: State) {
    const { data, settings, itemsPerContainer, title } = props
    const { showAll } = state

    if (!data.length) {
      return null
    }

    return (
      <section class='full-width Template-brand-featured qa-quicklinks-container quicklinks-wrapper homepage-widget-wrapper custom-quicklink'>
        <div class='sitewidth'>
          <div class='col'>
            {title ? <h3 className='widget__heading'>{title}</h3> : null}
            <QuickLinksList>
              {data.map((item, idx: number) => (
                <QuickLink
                  key={idx}
                  item={item}
                  idx={idx}
                  enableBorder={settings.enableBorder}
                  borderRadius={settings.borderRadius}
                  isVisibleDesktop={showAll || idx < itemsPerContainer}
                />
              ))}
            </QuickLinksList>
          </div>
        </div>
        {data.length > itemsPerContainer && (
          <ShowMoreButton
            quickLinksLength={data.length}
            itemsPerContainer={itemsPerContainer}
            showMore={this.showMoreHandler}
            showAll={showAll}
          />
        )}
      </section>
    )
  }
}
